@switch(((seSvc.currentSaleEvent$ | async)?.isPrivateInviteCounter)??false){
  @case (true) {
    <app-private-sale-users-private></app-private-sale-users-private>
  }
  @default {
    <app-private-sale-users-public></app-private-sale-users-public>
  }
}